import {EnvironmentInterface} from './EnvironmentInterface';

export const environment: EnvironmentInterface = {
    APP_NAME: 'Unifye',
    APP_ENV: 'local',
    production: false,
    devMode: true,
    API_DOMAIN: 'https://api.pre.unifye.com',
    API_SECURE_PROTOCOL: false,
    API_URL: 'https://api.pre.unifye.com',
    STORAGE_URL: 'https://api.pre.unifye.com/storage',
    APP_URL: 'https://client.pre.unifye.com',
    GENERAL_SITE_URL: 'www.unifye.com',
    REFRESH_NOTIFICATIONS: false,
    DISTRIBUTION_USER_IDS: [1],

    COMPANY_NAME: 'Unifye',
    COMPANY_NAME_LEGAL: 'Unifye Reparadora Legal Group, S.L.',
    COMPANY_ID_CIF: 'B88315890',
    COMPANY_ADDRESS: 'Avenida de la Vega, núm. 15, Edificio 2, planta 4ª, Alcobendas (Madrid), CP 28108',
    COMPANY_BANK_NAME: 'Caixabank',
    COMPANY_BANK_IBAN: 'ES06 2100 4910 3613 0024 6367',
    COMPANY_PHONE_LEGAL: '910 053 393',
    VAT_PERCENTAGE: 21,

    EMAIL_INFO: 'info@unifye.local',
    EMAIL_LEGAL: 'legal@unifye.local',
    EMAIL_ADMINISTRATION: 'administracion@unifye.local',
    EMAIL_CANCELLATIONS: 'cancelaciones@unifye.local',
    EMAIL_CONTRACT_CONTACT: 'contract@unifye.com',
    EMAIL_SUPPORTING_DOCUMENTS: 'justificantes@unifye.local',
    EMAIL_GDPR: 'dataprotectionofficer@unifye.local',

    GOOGLE_ANALYTICS_CODE: '',
    GOOGLE_ANALYTICS_ENABLED: false,
};
